/**
 * Story 204 — RN6.2/RN6.3/RN6.5: what the Backoffice needs from `GET languages/system-values` (C5/C6), indexed once:
 * which keys are system values, the params the catalogue declares for each (not the ones the key would suggest) and the
 * domains a code appears in (homonyms share one row, DL13).
 *
 * @param {{values?: Array<{kind: string, domain: string, code: string, defaultText: string, params: string[]}>}} response
 * @returns {{loaded: boolean, rows: Array<{code: string, domains: string[], params: string[]}>, has: (key: string) => boolean, paramsOf: (key: string) => string[], domainsOf: (key: string) => string[]}}
 */
export const indexSystemValues = (response) => {
  const values = Array.isArray(response?.values) ? response.values : []
  const byCode = new Map()
  for (const value of values) {
    const entry = byCode.get(value.code) || { code: value.code, domains: [], params: [] }
    if (!entry.domains.includes(value.domain)) entry.domains.push(value.domain)
    for (const param of value.params || []) if (!entry.params.includes(param)) entry.params.push(param)
    byCode.set(value.code, entry)
  }
  return {
    loaded: values.length > 0,
    rows: [...byCode.values()],
    has: (key) => byCode.has(key),
    paramsOf: (key) => (byCode.get(key) || { params: [] }).params,
    domainsOf: (key) => (byCode.get(key) || { domains: [] }).domains
  }
}

/** The index before (or without) an answer of C5: nothing is a system value. */
export const NO_SYSTEM_VALUES = indexSystemValues({ values: [] })
